import { motion } from "framer-motion";
import { CalendarClock, ShieldCheck, Timer } from "lucide-react";
import PickupFormCard from "@/components/landing/PickupFormCard";

const EASE = [0.16, 1, 0.3, 1];

const PERKS = [
  { icon: Timer, text: "Response within 24 hours" },
  { icon: CalendarClock, text: "Flexible pickup windows" },
  { icon: ShieldCheck, text: "Certificates on completion" },
];

export default function BookingForm() {
  return (
    <section id="book" className="relative bg-slate-100 py-24 sm:py-32" data-testid="booking-section">
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-eco/10 blur-3xl"
      />
      <div className="relative mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="lg:col-span-5"
        >
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-eco-dark" data-testid="booking-overline">
            Chapter 04 — Book a Pickup
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-navy sm:text-5xl" data-testid="booking-heading">
            Schedule your e-waste collection today
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600" data-testid="booking-subtext">
            Fill out the form and our logistics team will get back to you within 24 hours.
            Minimum of 5 high-value items required for free corporate pickups.
          </p>
          <ul className="mt-10 flex flex-col gap-5">
            {PERKS.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-navy">
                  <Icon className="h-5 w-5 text-eco" strokeWidth={2} />
                </span>
                <span className="text-sm font-bold text-navy">{text}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <PickupFormCard />
        </motion.div>
      </div>
    </section>
  );
}
